export var ANALYTICS_SCREEN_MANAGE_PROMOTIONS = 'marketplaceManagePromotionsScreen';
export var ANALYTICS_SCREEN_CREATE_PROMOTION = 'marketplaceCreatePromotionScreen';
export var ANALYTICS_SCREEN_PROMOTION_DETAILS = 'marketplacePromotionDetailsScreen';
export var ANALYTICS_SCREEN_PROMOTION_DETAILS_CODES = 'marketplacePromotionDetailsCodesScreen';
export var ANALYTICS_SCREEN_PROMOTION_DETAILS_PRICING = 'marketplacePromotionDetailsPricingScreen';